import { createSlice } from '@reduxjs/toolkit';
import getAdapter from '../getAdapter';

const deductionsAdapter = getAdapter();

const deductionsSlice = createSlice({
  name: 'deductions',
  initialState: deductionsAdapter.getInitialState(),
  reducers: {
    setDeductions: (state, { payload: { deductions } }) => {
      deductionsAdapter.setAll(state, deductions);
    },
  },
});

const selectors = deductionsAdapter.getSelectors(({ deductions }) => deductions);

export const getDeductions = (state) => selectors.selectAll(state);

export const getEnabledDeductions = (state) => getDeductions(state).filter(({ isEnabled }) => isEnabled);

export const { setDeductions } = deductionsSlice.actions;

export default deductionsSlice.reducer;
